// Lib
import Mousetrap from 'mousetrap';

const originalStopCallback = Mousetrap.prototype.stopCallback;

/**
 * Prevent all Mousetrap handlers.
 */
Mousetrap.pause = () => {
    Mousetrap.prototype.stopCallback = () => true;
};

/**
 * Resume all Mousetrap handlers.
 */
Mousetrap.resume = () => {
    Mousetrap.prototype.stopCallback = originalStopCallback;
};

export default Mousetrap;
